import { Avatar, Stack, Typography } from '@mui/material';
import { IDepartment, ISubject } from 'API/UniversalRequest/universalRequest';
import { useIsDesktop } from 'Hooks';
import { LeftArrow } from 'Images';
import { TAB_VALUE_TYPE } from 'Modules/UniversalRequest';

interface IParentCategoriesListItem {
  category: ISubject | IDepartment;
  onClick: () => void;
  svgIcon: string;
  tabValue: TAB_VALUE_TYPE;
}

export const ParentCategoriesListItem = ({
  category,
  onClick,
  svgIcon,
  tabValue,
}: IParentCategoriesListItem) => {
  const isDesktop = useIsDesktop();

  const RemunerationOfficersCategoryId = 4;
  const isRemunerationOfficers =
    tabValue === TAB_VALUE_TYPE.DEPARTMENT &&
    category.id === RemunerationOfficersCategoryId;

  let remunerationOfficers = {
    title: '',
    subTitle: '',
  };
  if (isRemunerationOfficers) {
    const titles = category.title.split(' (');
    titles[1] = '(' + titles[1];
    remunerationOfficers.title = titles[0];
    remunerationOfficers.subTitle = titles[1];
  }

  return (
    <Stack
      onClick={onClick}
      tabIndex={0}
      role='button'
      onKeyDown={(e) => e.key === 'Enter' && onClick()}
      sx={{
        width: isDesktop ? '280px' : '159px',
        height: isDesktop ? '80px' : '128px',
        alignItems: 'center',
        justifyContent: 'flex-start',
        bgcolor: 'white',
        boxShadow: '0px 4px 16px rgba(8, 30, 84, 0.12)',
        border: '1px solid #B7CCFF',
        borderRadius: '10px',
        textAlign: 'center',
        p: isDesktop ? '20px 16px' : '12px 16px',
        flexDirection: isDesktop ? 'row' : 'column',
        gap: '8px',
        cursor: 'pointer',
      }}
    >
      <Avatar
        src={svgIcon}
        alt=''
        sx={{
          width: '40px',
          height: '40px',
        }}
      />
      {isRemunerationOfficers ? (
        <Stack>
          <Typography
            variant='body2'
            sx={{
              mt: isDesktop ? '12px' : '6px',
              width: '100%',
              textAlign: 'start',
            }}
          >
            {remunerationOfficers.title}
          </Typography>
          <Typography
            variant='body6'
            sx={{
              textAlign: 'start',
            }}
          >
            {remunerationOfficers.subTitle}
          </Typography>
        </Stack>
      ) : (
        <Typography
          variant='body2'
          sx={{
            textAlign: isDesktop ? 'start' : undefined,
          }}
        >
          {category.title}
        </Typography>
      )}
      {isDesktop && (
        <Avatar
          src={LeftArrow}
          alt=''
          sx={{
            width: '32px',
            height: '32px',
            ml: '0px',
            mr: 'auto',
          }}
        />
      )}
    </Stack>
  );
};
